/* KALE — interacciones de la tienda (sin librerías) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Animaciones de entrada al hacer scroll */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.kl-reveal:not(.kl-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('kl-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('kl-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Cifras que cuentan al aparecer */
  function initContadores() {
    var els = document.querySelectorAll('[data-kl-count]');
    if (!els.length) return;
    function fmt(n, dec) {
      return n.toLocaleString('es-CO', { minimumFractionDigits: dec, maximumFractionDigits: dec });
    }
    function animar(el) {
      var fin = parseFloat(el.getAttribute('data-kl-count')) || 0;
      var dec = (String(el.getAttribute('data-kl-count')).split('.')[1] || '').length;
      var pre = el.getAttribute('data-kl-prefix') || '';
      var suf = el.getAttribute('data-kl-suffix') || '';
      if (reduce) { el.textContent = pre + fmt(fin, dec) + suf; return; }
      var t0 = null, dur = 1600;
      function paso(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var v = fin * (1 - Math.pow(1 - p, 3));
        el.textContent = pre + fmt(v, dec) + suf;
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(animar); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { animar(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Parallax suave de la imagen del hero */
  function initParallax() {
    var els = document.querySelectorAll('[data-kl-parallax]');
    if (!els.length || reduce) return;
    var ticking = false;
    function update() {
      els.forEach(function (el) {
        var k = parseFloat(el.getAttribute('data-kl-parallax')) || 0;
        var r = el.parentElement.getBoundingClientRect();
        var off = (r.top + r.height / 2 - window.innerHeight / 2) * k * -0.01;
        el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0) scale(1.06)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
    update();
  }

  /* Página de producto: galería, cantidad, variantes, añadir al carrito, barra fija */
  function initProducto() {
    document.querySelectorAll('[data-kl-producto]').forEach(function (wrap) {
      var principal = wrap.querySelector('[data-kl-principal]');
      var minis = Array.prototype.slice.call(wrap.querySelectorAll('[data-kl-mini]'));
      var actual = 0;
      function mostrar(i) {
        if (!minis.length || !principal) return;
        actual = (i + minis.length) % minis.length;
        var m = minis[actual];
        principal.style.opacity = '0';
        setTimeout(function () {
          principal.src = m.getAttribute('data-src');
          principal.removeAttribute('srcset');
          principal.alt = m.getAttribute('data-alt') || '';
          principal.style.opacity = '1';
        }, 160);
        minis.forEach(function (x) { x.classList.toggle('is-active', x === m); });
      }
      minis.forEach(function (m, i) { m.addEventListener('click', function () { mostrar(i); }); });
      var ant = wrap.querySelector('[data-kl-ant]'), sig = wrap.querySelector('[data-kl-sig]');
      if (ant) ant.addEventListener('click', function () { mostrar(actual - 1); });
      if (sig) sig.addEventListener('click', function () { mostrar(actual + 1); });

      // Cantidad
      var qty = wrap.querySelector('[data-kl-qty]');
      wrap.querySelectorAll('[data-kl-qty-btn]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(qty.value, 10) || 1;
          v += parseInt(b.getAttribute('data-kl-qty-btn'), 10);
          qty.value = Math.max(1, v);
        });
      });

      // Variantes
      var form = wrap.querySelector('form[data-kl-form]');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var boton = wrap.querySelector('[data-kl-add]');
      // "Comprar ahora": lleva directo a pagar con la variante y cantidad elegidas
      var directo = wrap.querySelector('[data-kl-directo]');
      function comprarDirecto() {
        if (!idInput || (directo && directo.disabled)) return;
        var raiz = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
        var cant = parseInt(qty ? qty.value : 1, 10) || 1;
        if (directo) directo.classList.add('is-loading');
        window.location.href = raiz + 'cart/' + idInput.value + ':' + cant;
      }
      if (directo) directo.addEventListener('click', comprarDirecto);
      var precio = wrap.querySelector('[data-kl-precio]');
      var antes = wrap.querySelector('[data-kl-antes]');
      var ahorro = wrap.querySelector('[data-kl-ahorro]');
      var dataEl = wrap.querySelector('[data-kl-variantes]');
      var variantes = dataEl ? JSON.parse(dataEl.textContent) : [];
      var moneda = wrap.getAttribute('data-kl-moneda') || '';
      function dinero(cents) {
        var n = cents / 100;
        try { return new Intl.NumberFormat('es-CO', { style: 'currency', currency: moneda || 'COP', maximumFractionDigits: (n % 1 === 0 ? 0 : 2) }).format(n); }
        catch (e) { return '$' + n.toLocaleString('es-CO'); }
      }
      var radios = wrap.querySelectorAll('[data-kl-opcion]');
      radios.forEach(function (r) {
        r.addEventListener('change', function () {
          var sel = [];
          wrap.querySelectorAll('[data-kl-opcion-grupo]').forEach(function (g) {
            var c = g.querySelector('input:checked');
            sel.push(c ? c.value : null);
          });
          var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
          if (!v) {
            if (boton) { boton.disabled = true; boton.querySelector('span').textContent = boton.getAttribute('data-txt-nodisp'); }
            return;
          }
          if (idInput) idInput.value = v.id;
          if (precio) precio.textContent = dinero(v.price);
          if (antes) { antes.textContent = v.compare_at_price > v.price ? dinero(v.compare_at_price) : ''; }
          if (ahorro) {
            if (v.compare_at_price > v.price) { ahorro.style.display = ''; ahorro.textContent = ahorro.getAttribute('data-prefijo') + ' ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; }
            else ahorro.style.display = 'none';
          }
          if (directo) directo.disabled = !v.available;
          if (boton) {
            boton.disabled = !v.available;
            boton.querySelector('span').textContent = v.available ? boton.getAttribute('data-txt') : boton.getAttribute('data-txt-agotado');
          }
          if (v.featured_media && minis.length) {
            var idx = minis.findIndex(function (m) { return m.getAttribute('data-media-id') == v.featured_media.id; });
            if (idx > -1) mostrar(idx);
          }
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        });
      });

      // Añadir al carrito (abre el carrito lateral si existe; si algo falla, envío normal)
      if (form) {
        form.addEventListener('submit', function (ev) {
          if (!window.fetch) return;
          ev.preventDefault();
          var err = wrap.querySelector('[data-kl-error]');
          if (err) err.style.display = 'none';
          if (boton) boton.classList.add('is-loading');
          var drawer = document.querySelector('cart-drawer');
          var body = { items: [{ id: parseInt(idInput.value, 10), quantity: parseInt(qty ? qty.value : 1, 10) || 1 }] };
          if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
          fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body)
          }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
            .then(function (res) {
              if (boton) boton.classList.remove('is-loading');
              if (!res.ok) {
                if (err) { err.textContent = res.j.description || res.j.message || 'No se pudo añadir.'; err.style.display = 'block'; }
                return;
              }
              if (drawer && typeof drawer.renderContents === 'function' && res.j.sections) {
                drawer.classList.remove('is-empty');
                try { drawer.renderContents(res.j); return; } catch (e) { /* sigue al carrito */ }
              }
              window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
            })
            .catch(function () { form.submit(); });
        });
      }

      // Barra de compra fija en móvil
      var sticky = wrap.querySelector('[data-kl-sticky]');
      var ancla = boton;
      if (sticky && ancla && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            var debajo = e.boundingClientRect.top < 0;
            sticky.classList.toggle('is-visible', !e.isIntersecting && debajo);
          });
        });
        io.observe(ancla);
        var sb = sticky.querySelector('button');
        if (sb) sb.addEventListener('click', function () {
          if (directo) { comprarDirecto(); return; }
          if (form.requestSubmit) form.requestSubmit(); else boton.click();
        });
      }
    });
  }

  function init() {
    document.documentElement.classList.remove('kl-no-js');
    initReveal();
    initContadores();
    initParallax();
    initProducto();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); initContadores(); initProducto(); });
})();
